






















































import { Component, Vue } from "vue-property-decorator";
import { readEntriesArray, readEntriesIsEmpty } from "@/store/uniabc/getters";
import {
  readError,
  readErrorTimeout,
  readHasUnsavedChanges
} from "@/store/appState/getters";

@Component({
  components: {}
})
export default class App extends Vue {
  private errorTimeout = readErrorTimeout(this.$store);
  private error: Error | null = null;
  private isError = false;

  get unsavedChangesState() {
    return readHasUnsavedChanges(this.$store);
  }

  get errorMsg() {
    return this.error?.message || "";
  }

  async created() {
    this.$store.watch(
      state => state.appState.error,
      () => {
        this.error = readError(this.$store);
        this.isError = true;
      }
    );

    window.addEventListener("beforeunload", ev => {
      if (this.unsavedChangesState) {
        const confirmationMessage =
          "You have unsaved changes. Do you really want to quit?";

        (ev || window.event).returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage;
      }
    });
  }

  private openRandomArticle() {
    if (!readEntriesIsEmpty(this.$store)()) {
      const entries = readEntriesArray(this.$store)().map(e => e.label);
      let entry = "";
      do {
        entry = entries[Math.floor(Math.random() * entries.length)];
      } while (entry === this.$route.params.label);
      this.$router.push(`/entry/${entry}`);
    }
  }

  private goToNextArticle() {
    if (!readEntriesIsEmpty(this.$store)()) {
      const entries = readEntriesArray(this.$store)().map(e => e.label);
      const nextEntryIdx = entries.indexOf(this.$route.params.label);
      const nextEntry = entries[nextEntryIdx + 1] || entries[0];
      this.$router.push(`/entry/${nextEntry}`);
    }
  }

  private goToPreviousArticle() {
    if (!readEntriesIsEmpty(this.$store)()) {
      const entries = readEntriesArray(this.$store)().map(e => e.label);
      const nextEntryIdx = entries.indexOf(this.$route.params.label);
      const nextEntry =
        entries[nextEntryIdx - 1] || entries[entries.length - 1];
      this.$router.push(`/entry/${nextEntry}`);
    }
  }
}
